import {RouterPaths} from "../routerPaths";
import {importPages} from "../lazyRoute";

const structureRoutes = [
    {
        path: RouterPaths.ACADEMICDEPARTMENT,
        element: importPages.AcademicDepartment,
    },
    {
        path: RouterPaths.EDUCATIONALDEGREES,
        element: importPages.EducationalDegree,
    },
    {
        path: RouterPaths.LEARNINGFORMAT,
        element: importPages.LearningFormat,
    },
    {
        path: RouterPaths.FACULTY,
        element: importPages.Faculty,
    },
    {
        path: RouterPaths.PROFESSION,
        element: importPages.Profession,
    },

    {
        path: RouterPaths.SUBJECT,
        element: importPages.Subject,
    },
]
export default structureRoutes;